import KyMethod from "./KyMethod"

export default class CaseStudiesRepositories extends KyMethod {
  protected async getRawCaseStudyList() {
    return this._getStrapiProtectedData("/case-studies?populate=*")
  }
  protected async getRawCaseStudyDetail(slug: string) {
    return this._getStrapiProtectedData(`/case-studies/${slug}?populate=*`)
  }

  protected async getRawCaseStudiesSummary() {
    return this._getStrapiProtectedData("/case-study-summarries?populate=*")
  }
}
